import config from "../../config.json"
import { TileLayer } from "react-leaflet";
import { VectorGrid } from "leaflet";
import VectorLayer from "./VectorLayer";
import VectorLayerSelected from "./VectorLayerSelected";
import { getVectorLayerInfo } from "../../utils/layer";
import { getRasterLayerInfo } from "../../utils/layer";
import { useState } from "react";
import { ProtobufLayer } from "./ProtobufLayer";


interface ActiveLayersProps {
    layerSelection: any,
    setLayerSelection: any,
    setDashboardData: any,
    selectedPolygonId: string,
    setSelectedPolygonId: any
}

export default function ActiveLayers({
    layerSelection,
    setLayerSelection,
    setDashboardData,
    selectedPolygonId,
    setSelectedPolygonId
}: ActiveLayersProps) {
    // Create variable for top and bottom layer
    let layer3 = null
    let layer2 = null
    let arnsberg = null
    let flurstueckflaechen = null
    let forsteinrichtungsflaechen = null

    /////////////////////////// Vector Layers ///////////////////////////
    layer3 = (
        <VectorLayer
            url={getVectorLayerInfo("arnsberg_grenze", "", false)[0].url}
            color="orange"
        />)

    arnsberg = (
        <>
            <VectorLayerSelected
                key={layerSelection.layer1.toString() + layerSelection.period.toString() + selectedPolygonId.toString()+"selected"}
                url={getVectorLayerInfo("arnsberg_grenze", "", false)[0].url}
                color="yellow"
                setDashboardData={setDashboardData}
                type="arnsberg"
                setSelectedPolygonId={setSelectedPolygonId}
                selectedPolygonId={selectedPolygonId}
            />
            <VectorLayer
                key={layerSelection.layer1.toString() + layerSelection.period.toString()}
                url={getVectorLayerInfo("arnsberg_grenze", "", false)[0].url}
                color="orange"
            />
        </>
    )

    flurstueckflaechen = (
        <>
            <VectorLayerSelected
                key={layerSelection.layer1.toString() + layerSelection.period.toString() + selectedPolygonId.toString()+"selected"}
                url={getVectorLayerInfo("flurstueckflaechen", "", false)[0].url}
                color="yellow"
                setDashboardData={setDashboardData}
                type="flurstueckflaechen"
                setSelectedPolygonId={setSelectedPolygonId}
                selectedPolygonId={selectedPolygonId}
            />
            <VectorLayer
                key={layerSelection.layer1.toString() + layerSelection.period.toString()}
                url={getVectorLayerInfo("flurstueckflaechen", "", false)[0].url}
                color="orange"
            />
        </>
    )

    forsteinrichtungsflaechen = (
        <>
            <VectorLayerSelected
                key={layerSelection.layer1.toString() + layerSelection.period.toString() + selectedPolygonId.toString()+"selected"}
                url={getVectorLayerInfo("forsteinrichtungsflaechen", "", false)[0].url}
                color="yellow"
                setDashboardData={setDashboardData}
                type="forsteinrichtungsflaechen"
                setSelectedPolygonId={setSelectedPolygonId}
                selectedPolygonId={selectedPolygonId}
            />
            <VectorLayer
                key={layerSelection.layer1.toString() + layerSelection.period.toString()}
                url={getVectorLayerInfo("forsteinrichtungsflaechen", "", false)[0].url}
                color="orange"
                setDashboardData={setDashboardData}
            />
        </>

    )

    /////////////////////////// Raster Layers ///////////////////////////
    switch (layerSelection.layer2) {
        case "WALDARTEN":
            layer2 = (
                <TileLayer
                    key={layerSelection.layer2.toString() + layerSelection.period.toString()}
                    url={getRasterLayerInfo("waldarten", "", false)[0].url}
                    zIndex={1000}
                />
            )
            break;
        case "BAUMHOEHE":
            layer2 = (
                <TileLayer
                    key={layerSelection.layer2.toString() + layerSelection.period.toString()}
                    url={getRasterLayerInfo("baumhoehe", "", false)[0].url}
                    zIndex={1000}
                />
            )
            break;
        case "BIOMASSE":
            layer2 = (
                <TileLayer
                    key={layerSelection.layer2.toString() + layerSelection.period.toString()}
                    url={getRasterLayerInfo("biomasse_agb", "", false)[0].url}
                    zIndex={1000}
                />
            )
            break;
        case "KOHLENSTOFFGEHALT":
            layer2 = (
                <TileLayer
                    key={layerSelection.layer2.toString() + layerSelection.period.toString()}
                    url={getRasterLayerInfo("kohlenstoff", "", false)[0].url}
                    zIndex={1000}
                />
            )
            break;
        case "WALDVITALITAET":
            layer2 = (
                <TileLayer
                    key={layerSelection.layer2.toString() + layerSelection.period.toString()}
                    url={getRasterLayerInfo("biomasse", layerSelection.period, true)[0].url}
                    zIndex={1000}
                />
            )
            break;
        case "WASSERDEFIZIT":
            layer2 = (
                <TileLayer
                    key={layerSelection.layer2.toString() + layerSelection.period.toString()}
                    url={getRasterLayerInfo("wasserdefizit", layerSelection.period, true)[0].url}
                    zIndex={1000}
                />
            )
            break;
        case "SCHADFLAECHEN":
            console.log("SCHADFLÄCHEN")
            layer2 = (
                <TileLayer
                    key={layerSelection.layer2.toString() + layerSelection.period.toString()}
                    url={getRasterLayerInfo("schadflaechen", layerSelection.period, true)[0].url}
                    zIndex={1000}
                />
            )
            break;
    }

    return (
        <>
            {layerSelection.layer1 === "ARNSBERG" && arnsberg}
            {layerSelection.layer1 === "FLURSTUECKFLAECHEN" && flurstueckflaechen}
            {layerSelection.layer1 === "FORSTEINRICHTUNGSFLAECHEN" && forsteinrichtungsflaechen}
            {layer3}
            {layer2}
        </>
    )
}